import React from 'react';
// import { connect } from 'react-redux';
import {
  LocalForm,
  Control,
  actions
} from 'react-redux-form';

import {
  is_numeric,
  capitalize
} from '../helpers'

const { FormSelect, toast, updateTextFields, Tooltip } = window.M

class FiltersUpdateForm extends React.Component {
  constructor () {
    super()
    this.state = {
      operationSelector: null,
      fieldSelector: null,
      appendSelector: null,
      valueSelector: null,
      operation: null,
      field: ''
    }
  }

  componentDidMount() {
    this.formInit()

    const el = document.getElementById('patternHelpActions')
    Tooltip.init(el, {
      html:
        `<div class="patternDiv">
          <div class="patternDivHead">Examples</div>
          <div>[ab]: Pattern contains letter "a" or letter "b"</div>
          <div>cc[ab]cc: Pattern contains "ccacc" or "ccbcc"</div>
          <div>[^ab]: Pattern contains does not contains letters "a" and "b"</div>
          <div>(aa|bb): Pattern contains "aa" or "bb"</div>
          <div>ab: Pattern contains "ab"</div>
          <div>\\bab\\b: Pattern contains word "ab"</div>
          <div>\\Aab: Pattern begins with "ab"</div>
          <div>ab\\z: Pattern ends with "ab"</div>
          <div>\\d+: Pattern contains one or more numerical digits</div>
        </div>`
    })

  }

  attachDispatch(dispatch) {
    this.formDispatch = dispatch;
  }

  handleSubmit(values) {
    console.log(values)
    const { operations } = this.props
    const current_fields = operations.map(op => op.field)
    const current_operations = operations.map(op => op.operation)
    console.log(current_fields)

    const { operation, field, value, pattern } = values

    if (current_operations.indexOf("revert_row") > -1) {
      return toast({
        html: `Reverting to original row cannot be combined with other operations`
      })
    }

    if (current_fields.indexOf(field) > -1) {
      return toast({
        html: `Column ${field} has already an operation assigned to it`
      })
    }

    const number_fields=["boost"]
    const append_fields=["append","prepend","append_field","prepend_field"]

    if ( number_fields.indexOf(field) > -1 && operation === "replace" ) {
      return toast({
        html: `Column ${field} is numeric and does not support pattern matching`
      })
    }

    if ( number_fields.indexOf(field) > -1 && append_fields.indexOf(field) > -1 ) {
      return toast({
        html: `Column ${field} is numeric and does not support appending/prepending`
      })
    }

    if ( number_fields.indexOf(field) > -1 && !is_numeric(value) && ( operation==="set" || operation === "replace") ) {
      return toast({
        html: `Column ${field} must have numeric value`
      })
    }

    if ( operation === "set" && !value ) {
      return toast({
        html: `Set value cannot be empty.\nIf you want value to be blank, select the "Clear" operation`
      })
    }

    if (operation === "replace" && !pattern ) {
      return toast({
        html: `Match pattern cannot be empty.\nIf you want to replace everything, select the "Set value" operation`
      })
    }

    if ( ( operation === "append" || operation === "prepend" ) && !value ) {
      return toast({
        html: `Appending or prepending empty text has no effect`
      })
    }

    let newvalues
    if (operation === "revert_row") {
      newvalues = {
        ...values,
        key: '',
        field: '',
      }
    } else {
      newvalues = {
        ...values
      }
    }
    this.props.addOperation(newvalues)

    this.formDispatch(actions.reset('localOperation'));

    setTimeout(function(self) {
      self.formInit()
    }, 150, this)

  }


  formInit() {
    const { columns } = this.props

    const fields = columns.filter( field => {
      return field.listable === true;
    })

    const { operationSelector, fieldSelector, appendSelector } = this.state

    if ( operationSelector !== null ) {
      operationSelector.destroy()
    }

    let el = document.getElementById('operationSelector')
    let selector = FormSelect.init(el)
    this.setState({operationSelector: selector})

    if ( fieldSelector !== null ) {
      fieldSelector.destroy()
    }

    el = document.getElementById('fieldSelector')
    selector = FormSelect.init(el)
    this.setState({fieldSelector: selector})

    if ( appendSelector !== null ) {
      appendSelector.destroy()
    }

    el = document.getElementById('appendSelector')
    selector = FormSelect.init(el)
    this.setState({appendSelector: selector})

    this.setState({operation: null, field: fields[0].key})

    el = document.getElementById('valueFieldBoolean')
    selector = FormSelect.init(el)
    this.setState({valueSelector: selector})

    this.formDispatch(actions.change('localOperation.append', columns[0].key));
    this.formDispatch(actions.change('localOperation.field', fields[0].key));

    updateTextFields()

  }

  setOperation(e) {
    const operation = e.target.value
    if (operation === "revert_row" && this.props.operations && this.props.operations.length > 0) {
      return toast({
        html: `Reverting a row cannot be combined with other actions`
      })
    }
    const { fieldSelector } = this.state

    this.setState({
      operation: operation
    })

    if ( fieldSelector !== null ) {
      fieldSelector.destroy()
    }

    setTimeout(function(self) {
      const el = document.getElementById('fieldSelector')
      const selector = FormSelect.init(el)
      self.setState({fieldSelector: selector})
      self.formDispatch(actions.change('localOperation.field', el.value))
    }, 50, this)

  }

  setField(e) {
    const field = e.target.value
    console.log(field)
    this.setState({
      field: field
    })

  }


  render() {

    const { operation } = this.state
    const { columns } = this.props
    const batchIsBoolean = (operation === "set" && ["published", "newentry", "removed"].indexOf(this.state.field) > -1)

    const fields = columns.filter( field => {
      return field.listable === true;
    })

    const showPatternHint = ( operation === "replace" ) ? true : false

    const patternHintClass = showPatternHint ? 'col l2 xl2' : 'hide'


    return (
      <div className="col s4 l4 xl4">
      <div className="z-depth-2 pad10">
        <LocalForm
        style={{display:'inline'}}
        model="localOperation"
        getDispatch={(dispatch) => this.attachDispatch(dispatch)}
        onSubmit = { (values) => {
          this.handleSubmit(values)
        }}
        initialState={{
          operation: '',
          append: '',
          field: fields[0].key,
          pattern: "",
          value: ""
        }}
        >
          <div className="input-field">
            <label htmlFor="operationSelector" className="active">Select Operation</label>
            <Control.select id="operationSelector" model= ".operation" onChange={e=>{
              this.setOperation(e)
            }}>
              <option value="">Select operation</option>
              <option value="set">Set value to a column</option>
              <option value="clear">Clear a column</option>
              <option value="replace">Replace a pattern</option>
              <option value="append">Append text to column</option>
              <option value="prepend">Prepend text to column</option>
              <option value="append_field">Append a column value to another column</option>
              <option value="prepend_field">Prepend a column value to another column</option>
              <option value="revert_row">Revert row to its original values</option>
              <option value="revert_column">Revert a column to its original</option>
              <option value="revert_append">Revert column and append value</option>
              <option value="revert_prepend">Revert column and prepend value</option>
            </Control.select>
          </div>

          <div className={( operation === "append_field" || operation === "prepend_field" ) ? "input-field" : "hide"}>
            <label htmlFor="appendSelector" className="active">Select Column to Copy</label>
            <Control.select id="appendSelector" model= ".append" defaultValue={fields[0].key} onChange={e=>{
              // this.setOperation(e)
            }}>
            {
              columns.map((column, index)=>{
                return(
                  <option value={column.key} key={index}>{column.name}</option>
                )
              })
            }
            </Control.select>
          </div>

          <div className={(operation !== "" && operation !== undefined && operation !== null && operation !== "revert_row") ? "input-field" : "hide"}>
            <label htmlFor="fieldSelector" className="active">Select Target Column</label>
            <Control.select id="fieldSelector" model= ".field" defaultValue={fields[0].key} onChange={e=>{
              this.setField(e)
            }}>
            {
              fields.filter(column => !(operation !== 'set' && ["published", "newentry", "removed"].indexOf(column.key) > -1) ).map((column, index)=>{
                return <option value={column.key} key={index}>{column.name}</option>
              })
            }
            </Control.select>
          </div>


          <div className={( operation === "replace") ? "input-field" : "hide"}>
            <label htmlFor="patternField">Pattern to replace</label>
             <Control.text id="patternField" model=".pattern" />
          </div>

          <div className={(operation === "set" || operation === "replace" || operation === "append" || operation === "prepend" || operation === "revert_prepend" || operation === "revert_append") ? "input-field" : "hide"}>
            <label htmlFor="valueField" className={ !batchIsBoolean ? '' : 'hide'}>{operation && capitalize(operation.replace(/revert_/,''))} Value</label>
            <Control.text id="valueField" model=".value" className={ !batchIsBoolean ? '' : 'hide'}/>
            <div className={ batchIsBoolean ? '' : 'hide'}>
              <label htmlFor="valueFieldBoolean" className={ batchIsBoolean ? 'active' : 'hide'}>{operation && capitalize(operation)} Value</label>
              <Control.select id="valueFieldBoolean" model=".value" defaultValue={batchIsBoolean ? "true" : ''} className={ batchIsBoolean ? '' : 'hide'}>
                <option value="true">True</option>
                <option value="false">False</option>
              </Control.select>
            </div>
          </div>

          <div className="row">
            <div className="col l9 xl9">
              <button type="submit" className="btn red darken-1 waves-effect waves-light pull-right" disabled={(operation===null || operation==="") ? "disabled" : ""}><i className="material-icons right">navigate_next</i>Add </button>
            </div>
            <div className={ patternHintClass } style={{marginTop: "7px", height: "10px", float: "right"}}>
              <i id="patternHelpActions" className="material-icons c-red">help_outline</i>
            </div>
          </div>


        </LocalForm>
      </div>

      <div>
      <a href="" className="btn red darken-1 waves-effect waves-light mr-10" style={{float: 'right', marginTop: 14}} onClick={(e)=>{
        e.preventDefault()
        this.props.hide()
      }}>Cancel All</a>
      </div>
      </div>
    )
  }
}

export default FiltersUpdateForm



// WEBPACK FOOTER //
// ./src/js/components/FiltersUpdateForm.js